export default function ProjectLoading() {
  return (
    <div className="bg-white rounded-[2.5rem] p-4 shadow-[0_20px_50px_rgba(0,0,0,0.02)] border border-gray-50/50 flex flex-col h-full animate-pulse">
      {/* Image Placeholder */}
      <div className="relative h-64 w-full rounded-4xl bg-gray-200 mb-6" />

      {/* Info Content Placeholder */}
      <div className="px-2 grow space-y-4">
        <div className="h-6 bg-gray-200 rounded-lg w-3/4" /> {/* Title */}
        <div className="space-y-2">
          <div className="h-3 bg-gray-100 rounded-md w-full" />{" "}
          {/* Description Line 1 */}
          <div className="h-3 bg-gray-100 rounded-md w-5/6" />{" "}
          {/* Description Line 2 */}
        </div>
      </div>

      {/* Footer Placeholder */}
      <div className="mt-8 px-2 pt-4 border-t border-gray-50 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-gray-200" /> {/* Avatar */}
          <div className="space-y-2">
            <div className="h-3 bg-gray-200 rounded-md w-16" /> {/* Username */}
            <div className="h-2 bg-gray-100 rounded-md w-10" />{" "}
            {/* Verified badge */}
          </div>
        </div>
        <div className="h-2 bg-gray-50 rounded-md w-12" /> {/* Order No */}
      </div>
    </div>
  );
}
